<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>首充配置</span>
          <el-button style="margin-left: 5px" @click="addCountry">+</el-button>
        </div>
        <refreshCfg />
        <el-form>
          <el-row v-for="(item, index) in tableData" :key="index">
            <el-card style="margin-top: 15px">
              <el-form-item label="国家" style="margin-top: 10px;">
                <el-select v-model="item.country" multiple placeholder="请选择" style="width: 600px">
                  <el-option
                    v-for="item in lang"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-table :data="item.data" border stripe>
                  <el-table-column prop="start" label="等级范围">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.min_level" style="width: 45%" placeholder="最小等级" />
                      -
                      <el-input v-model.number="scope.row.max_level" style="width: 45%" placeholder="最大等级" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="life_time" label="存在时间">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.life_time" placeholder="存在时间" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="价格">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.price" placeholder="请选择" @change="(v)=>priceChange(v, index, scope.$index)">
                        <el-option
                          v-for="item in shopSku"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="origPriceSku" label="原价SKU">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.origPriceSku" clearable style="width: 200px;" placeholder="请选择">
                        <el-option
                          v-for="item in origPriceSkuSelect"
                          :key="item.sku"
                          :label="item.label"
                          :value="item.sku"
                        />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="discount" label="折扣">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.discount" placeholder="折扣" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.status" placeholder="请选择">
                        <el-option
                          v-for="item in statusType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="skin_dir" label="配图文件路径">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.skin_dir" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="skin_dir" label="奖励">
                    <template slot-scope="scope">
                      {{ getRewardList(scope.row.prize_json) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="奖励配置">
                    <template slot-scope="scope">
                      <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[index][scope.$index].visible = true">
                        奖励配置
                      </el-button>

                      <el-drawer
                        title="奖励配置"
                        :visible.sync="drawerArr[index][scope.$index].visible"
                        direction="rtl"
                        size="950px"
                      >
                        <commonReward v-model="scope.row.prize_json" />
                      </el-drawer>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button v-permisaction="['config:firstPurchasv2:del']" type="danger" @click="del(index, scope.$index, scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button v-permisaction="['config:firstPurchasv2:add']" type="primary" style="margin-top: 10px" @click="add(index)">+</el-button>
                <el-button v-permisaction="['config:firstPurchasv2:add']" type="primary" style="margin-top: 10px" @click="onSubmit(item)">保存</el-button>
              </el-form-item>
            </el-card>
          </el-row>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { deleteShopCfg, getCountryMap, getShopCfgList, getSku, updateShopCfg } from '@/api/config/shop-cfg'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import refreshCfg from '@/views/config/first-purchase-v2/components/refreshCfg.vue'
import commonReward from '@/components/Reward/index.vue'
export default {
  name: 'FirstPurchasev2',
  components: {
    refreshCfg,
    commonReward
  },
  data() {
    return {
      drawerArr: {},
      shopSku: [],
      rewardType: [],
      countryArr: [{ label: '英国', value: 'en' }],
      statusType: [{ label: '上架', value: 1 }, { label: '下架', value: 0 }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 1000,
        type: 6
      },
      gType: 6,
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      formData: [
        {
          'id': 0,
          'gid': 601,
          'g_type': this.gType,
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': '',
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'prize_json': []
        }
      ],
      skinId: [62, 19, 67, 68],
      chessId: [],
      shield: [],
      sieve: [],
      areaId: [],
      lang: [],
      tableData: [],
      origPriceSkuSelect: []
    }
  },
  created() {
    this.getRewardTypeData()
    this.getSkuList()
    this.getTables()
    this.getCountryList()
  },
  methods: {
    addCountry() {
      this.tableData.push({ country: '', data: [] })
      const len = this.tableData.length - 1
      this.$set(this.drawerArr, len, [])
    },
    handleClose(done, index) {
      this.drawerArr[index].visible = false
    },
    priceChange(v, inx, index) {
      let sku = ''
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
      }

      if (!sku) {
        this.msgError('sku有误')
        return
      }

      // console.log(' this.formData', this.tableData)
      this.tableData[inx].data[index].sku = sku
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          this.origPriceSkuSelect = []
          this.origPriceSkuSelect.push({ label: '原价', value: '原价', sku: '' })
          this.origPriceSkuSelect.push({ label: '客户端计算', value: '客户端计算', sku: '1' })
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
            this.origPriceSkuSelect.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getCountryList() {
      getCountryMap().then(res => {
        if (res.code === 200) {
          this.lang = []
          for (const i in res.data) {
            this.lang.push({ label: res.data[i], value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(index, idx) {
      this.tableData[index].data[idx].prize_json.push({
        propsId: 1,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    removeReward(index, idx, i) {
      this.tableData[index].data[idx].prize_json = this.tableData[index].data[idx].prize_json.filter((item, key) => {
        return i !== key
      })
    },
    onSubmit(formData) {
      console.log('formData', formData)
      const data = formData.data
      const country = formData.country
      for (const i in data) {
        const val = data[i]
        if (val.min_level > val.max_level) {
          this.msgError('最小等级不能大于最高等级')
          return
        }
        data[i].other_json = country
      }
      const postData = JSON.stringify(data)
      console.log(postData)
      updateShopCfg({ data: postData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getShopCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.drawerArr = []
          const countryMap = {}
          res.data.list.forEach((item, index) => {
            const c = item.other_json.join('-')
            countryMap[c] = { 'country': item.other_json, 'data': [] }
          })
          this.tableData = []
          res.data.list.forEach((item, index) => {
            const c = item.other_json.join('-')
            for (const i in countryMap) {
              if (c === i) {
                countryMap[i].data.push(item)
              }
            }
          })
          let idx = 0
          for (const i in countryMap) {
            this.tableData.push(countryMap[i])
            this.$set(this.drawerArr, idx, [])
            countryMap[i].data.forEach(() => {
              this.drawerArr[idx].push({ visible: false })
            })
            idx++
          }
          console.log('countryMap', this.tableData)

          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add(index) {
      this.tableData[index].data.push({
        'id': 0,
        'gid': 601,
        'g_type': this.gType,
        'min_level': 0,
        'max_level': 0,
        'life_time': 0,
        'price': this.shopSku[0].value,
        'sku': this.shopSku[0].sku,
        'discount': 0,
        'skin_dir': '',
        other_json: [],
        'status': 0,
        'prize_json': []
      })
      this.drawerArr[index].push({ visible: false })
    },
    del(index, key, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteShopCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.tableData[index].data = this.tableData[index].data.filter((item, idx) => {
          return idx !== key
        })
      }
    }, getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
